import { z } from 'zod';

/**
 * Shared password strength policy for newly set passwords.
 * Mirrors the server-side policy in packages/server/src/lib/passwordPolicy.ts.
 * Only enforced when a password is created or changed - never on login,
 * so existing passwords that predate this policy keep working.
 */
export const passwordSchema = z
    .string()
    .min(8, 'Das Passwort muss mindestens 8 Zeichen lang sein.')
    .regex(/[A-Z]/, 'Das Passwort muss mindestens einen Großbuchstaben enthalten.')
    .regex(/[a-z]/, 'Das Passwort muss mindestens einen Kleinbuchstaben enthalten.')
    .regex(/[0-9]/, 'Das Passwort muss mindestens eine Zahl enthalten.')
    .regex(/[^A-Za-z0-9]/, 'Das Passwort muss mindestens ein Sonderzeichen enthalten.');

export const passwordRequirements = [
    'Mindestens 8 Zeichen',
    'Mindestens ein Großbuchstabe',
    'Mindestens ein Kleinbuchstabe',
    'Mindestens eine Zahl',
    'Mindestens ein Sonderzeichen',
];

export const passwordRequirementsText =
    '8 Zeichen, Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen';
